import { render } from "./Chapter.vue?vue&type=template&id=c5b0ed16"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=c5b0ed16&lang=less"
script.render = render

export default script